import React, {useState, useEffect} from "react";
import Overviewbar from "../Overviewbar";
import "../../cssfiles/homepage.css";
//import LeftPane from "./LeftPane";
//import Dashboard from "./Dashboard";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Box, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import Typography from '@mui/material/Typography';
import Year from "../CommonComponents/Year";
import Searchall from "../CommonComponents/Search";
//import RightPane from "./RightPane";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Alert from '@mui/material/Alert';
//import { statusCode } from "../Restclient/datacollection";
import AlarmDataArea from "./AlarmDataArea";
import AlarmLeftPane from './AlarmLeftPane';
//import AlarmRightPane from "./AlarmRightPane";

export default function AlarmData (props) {
    const overviewstate = useSelector((state) => state.mainpagedata.overviewbarstate)
    const selectedtreepath = useSelector((state) => state.mainpagedata.alarmtreepathselected)
    const tabpathselected = useSelector((state) => state.mainpagedata.selectedtabpath)
    const path = useSelector((state) => state.mainpagedata.selectedpath)

    const [pagesize, setPagesize] = useState(370)
    const [pathselected, setPathselected] = useState([
        <Typography key="Dashboards" className="crumbs" style={{fontSize: '14px', fontWeight: 400}}>
            Plant
        </Typography>,
        <Typography key="Dashboards" className="crumbs" style={{fontSize: '14px', fontWeight: 400}}>
            Dashboard
        </Typography>,
        <Typography key="Dashboards" className="crumbs" style={{fontSize: '14px', fontWeight: 400}}>
            Dashboard
        </Typography>
    ])

    useEffect(() => {
        if (overviewstate) {
          setPagesize(265);
        } else {
          setPagesize(235);
        }
      }, [overviewstate]);

    useEffect(() => {
        var newpath = []
        for(let i=0; i< selectedtreepath.length; i++) {
            newpath.push(
                <Typography key="Dashboards" className="crumbs" style={{fontSize: '14px', fontWeight: 400}}>
                    {selectedtreepath[i]}
                </Typography>
            )
        }
        /* 
         for(let i=0; i< tabpathselected.length; i++) {
            newpath.push(
                <Typography key="Dashboards" className="crumbs" style={{fontSize: '14px', fontWeight: 400}}>
                    {tabpathselected[i]}
                </Typography>
            )
        }
        */
        setPathselected(newpath)
    },[selectedtreepath])

    var doubleright=">>";
    const [checkfilterlist, setCheckfilterlist] = useState({
        checkedtag:false,
        checkedgroup:false,
        checkedunack:false,
        checkedactive:false
    })
    const [rightpanevisible,setRightPaneVisible] = useState(false);
/*height: calc(100vh - 60px);*/
    return (
        
        <Box className="configuration">
             <Overviewbar/>
            <div style={{display: 'flex', flexDirection: 'row', marginRight:"18px"}}> 
                <div className="breadcrumb" style={{flexGrow: 1 ,marginRight:"4px", marginLeft:"16px"}} >
                    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" sx={{color:'var(--GreyVariation_2)'}}/>} style={{padding: '10px 12px 10px 12px', textAlign: 'center'}}>
                        {pathselected}
                    </Breadcrumbs>
                </div>
                <Searchall/>
                <Year/>
            </div> 
            <Box style={{ display: 'flex', flexDirection: 'row', height: `calc(100vh - ${pagesize}px)`, padding: '0px 16px', width: '100%', paddingRight:"0px", gap: '16px', boxSizing: 'border-box' }}>
                <AlarmLeftPane setCheckfilterlist={setCheckfilterlist}/> 
                <AlarmDataArea pathselected={pathselected} setPathselected={setPathselected} setRightPaneVisible={setRightPaneVisible} rightpanevisible={rightpanevisible} setCountAlarms={props.setCountAlarms} checkfilterlist={checkfilterlist} setCheckfilterlist={setCheckfilterlist}/>
            </Box>
        </Box>
    )
}